import React from 'react'
import PropTypes from 'prop-types'

import App from 'components/App'
import ResourceBlocker from 'components/ResourceBlocker'

import GPCHandler from './GPCHandler'


export default function ResourceBlockerApp({ consentConfig, cookiePolicy, countryCode, isGPC, rootElem, website }) {
  const content = ( isGPC ) ? <GPCHandler /> : (
    <ResourceBlocker
      cookiePolicy={ cookiePolicy }
    />
  )

  // A GPC visitor has no prompt copy to repaint: the signal is recorded
  // on mount and the only UI is a fixed-position toast. Waiting on the
  // translations would delay honoring the signal and buy nothing.
  const isFirstPaintGated = !isGPC

  return (
    <App
      consentConfig={ consentConfig }
      countryCode={ countryCode }
      isFirstPaintGated={ isFirstPaintGated }
      rootElem={ rootElem }
      website={ website }
    >
      { content }
    </App>
  )
}

ResourceBlockerApp.propTypes = {
  isGPC: PropTypes.bool.isRequired,

  consentConfig: App.propTypes.consentConfig,
  cookiePolicy: ResourceBlocker.propTypes.cookiePolicy,
  countryCode: App.propTypes.countryCode,
  rootElem: App.propTypes.rootElem,
  website: App.propTypes.website,
}
